
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/products/plp",
      function () {
        return require("private-next-pages/india/products/plp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/products/plp"])
      });
    }
  